export default "__VITE_ASSET__dUJLsw7p__"